module.exports = __webpack_public_path__ + "static/media/GunaldiCreateImporterSegment.df8afe0c.svg";